import {Component,} from '@angular/core';
import {AtributoEspecime, AtributoMonitoramento, Grupo} from "../../../../domain/enums";
import {MetodoAmostragem} from "../../../../domain/MetodoAmostragem";
import {OneToManyComponent} from "../../one-to-many.component";

@Component({
  selector: 'app-metodo',
  templateUrl: './edit-metodos.component.html',
  styleUrls: ['./edit-metodos.component.scss'],
})
export class EditMetodosComponent extends OneToManyComponent<MetodoAmostragem>  {
  grupos = Object.values(Grupo)
  opcoesAtributos = Object.values(AtributoMonitoramento)
  atributosEspecime = Object.values(AtributoEspecime)

  override newObject(): MetodoAmostragem {
    const novo =  new MetodoAmostragem();
    novo.listaAtributosEspecime = [AtributoEspecime.observacoes, AtributoEspecime.arquivos, AtributoEspecime.individuos]
    return novo
  }
}
